import React, { useEffect, useRef, useState } from "react";
import {
  Dimensions,
  Image as ImageNative,
  ImageBackground,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import ReactMarkdown from "react-markdown";
import BounceLoader from "react-spinners/BounceLoader";
import headbreaker, { Canvas, painters } from "headbreaker";

import Menu from "../../menu";
import style from "../../../Styles/CheckIn";
import globalstyle from "../../../Styles/Globals/globals";
import {
  getMultimedia,
  getRecursText,
  getRecursURL,
} from "../../../Functions/getRecurs";

function Puzzle(RouterData) {
  const { poi, projecte, itinerari, recursos, idioma, currentItinerari } =
    RouterData.route.params;

  const poiData = itinerari.pois.find((e) => e.id === poi.id);
  const premi = projecte.premis.find((e) => e.id === poiData.premi);
  const punts = premi?.punts || 100;
  const [continuar, setContinuar] = useState(false);
  const [loading, setLoading] = useState(false);
  const puzzleRef = useRef(null);

  if (!premi) {
    alert("El poi no té premi!");
  }

  useEffect(() => {
    if (continuar) {
      return;
    }

    const puzzle = puzzleRef.current;

    const image = new Image();
    image.src = getMultimedia(poiData, "resposta_imatge_1");
    image.onload = () => {
      const canvas = new Canvas(puzzle.id, {
        width: Dimensions.get("screen").width,
        height: 650,
        pieceSize: { x: 110, y: 75 },
        proximity: 20,
        borderFill: 10,
        strokeWidth: 2,
        lineSoftness: 0.12,
        image,
        painter: new painters.Konva(),
      });

      canvas.adjustImagesToPuzzleWidth(image);

      canvas.autogenerate({
        horizontalPiecesCount: poiData["Quizz" + idioma]?.pecesHortizonal || 3,
        verticalPiecesCount: poiData["Quizz" + idioma]?.pecesVertical || 3,
        insertsGenerator: headbreaker.generators.random,
      });

      canvas.shuffle(0.7);

      canvas.attachSolvedValidator();
      canvas.onValid(() => {
        setContinuar(true);
      });

      canvas.draw();
    };
  }, [continuar]);

  const _paintImage = () => {
    if (continuar) {
      return (
        <>
          <View
            nativeID={"puzzle"}
            style={{
              flex: 30,
              width: "80%",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ImageNative
              resizeMode="contain"
              style={style.image}
              source={{ uri: getMultimedia(poiData, "resposta_imatge_1") }}
            />
          </View>
          <View
            style={[
              { flex: 20, justifyContent: "center", alignItems: "center" },
              style.descripcio,
            ]}
          >
            <ScrollView
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
            >
              <ReactMarkdown>
                {poiData["descripcioDetallada" + idioma]}
              </ReactMarkdown>
            </ScrollView>
          </View>
        </>
      );
    }

    return (
      <>
        <View
          style={{
            flex: 30,
            width: "80%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <View
            style={[
              { flex: 2, justifyContent: "center", alignItems: "center" },
              style.descripcio,
            ]}
          >
            <ScrollView
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
            >
              <ReactMarkdown>{poiData[`Descripcio${idioma}`]}</ReactMarkdown>
            </ScrollView>
          </View>
          <View
            style={{
              flex: 10,
            }}
          >
            <div ref={puzzleRef} id={"puzzle"} style={{ ...style.image }}></div>
          </View>
        </View>
      </>
    );
  };

  const _renderBoto = () => {
    if (loading) {
      setTimeout(() => {
        setLoading(false);
        setContinuar(true);
      }, 1000);

      return (
        <BounceLoader
          size={50}
          color={"#006fb7"}
          loading={loading}
          speedMultiplier={1.5}
        />
      );
    }

    if (!continuar) {
      return <></>;
    }

    return (
      <TouchableOpacity
        onPress={() => {
          currentItinerari.pois.find((e) => e.id == poi.id).punts =
            punts <= 0 ? 0 : punts;
          RouterData.navigation.navigate("Premi", RouterData.route.params);
        }}
      >
        <Text style={globalstyle.botoContinuar}>
          {getRecursText(recursos, "text_continuar", idioma)}
        </Text>
      </TouchableOpacity>
    );
  };

  return (
    <View style={{ flex: 1 }}>
      <ImageBackground
        source={{
          uri: getRecursURL(recursos, "background_default", idioma),
        }}
        style={{ flex: 1 }}
      >
        <View
          style={{
            flex: 10,
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
            width: "90%",
          }}
        >
          <ScrollView
            contentContainerStyle={style.scroll}
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
          >
            <View
              style={{
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Text style={style.titol}> {poiData["Nom" + idioma]} </Text>
            </View>
          </ScrollView>
        </View>
        <View
          style={{ flex: 50, justifyContent: "center", alignItems: "center" }}
        >
          {_paintImage()}
        </View>
        <View
          style={{
            flex: 10,
            justifyContent: "center",
            alignItems: "center",
            zIndex: -1,
          }}
        >
          {_renderBoto()}
        </View>
        <View style={{ flex: 10 }}><Menu projecte={RouterData.route.params}></Menu></View>
      </ImageBackground>
    </View>
  );
}

export default Puzzle;
